import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Alert, Button } from 'react-bootstrap';
import _, { find as _find } from 'lodash';
import { createObjectURL } from 'helpers/upload';
import ReactTooltip from 'react-tooltip';
import withRouter from 'js/withRouter';
import { injectIntl } from 'react-intl';
import EXIF from 'exif-js';
import { confirmAlert } from 'react-confirm-alert';
import { S3_LINKS } from 'js/constants';
import ImageEditor from 'cc-editor/helpers/ImageEditor';
import Loader from '../../../components/layout/Loader';
import EditorApplyStyles from '../EditorApplyStyles';
import MediaTabs from '../MediaTabs';
import FormInput from '../../../components/forms/FormInput';

const ContextModal = ({ children }) => {
  return ReactDOM.createPortal(children, document.getElementById('context-modal'));
};

class ImageElement extends React.Component {
  constructor(props) {
    super(props);
    this.imageRef = React.createRef();
    this.state = {
      showImageTooSmallError: false,
      showImageEditor: false,
      showMedia: false,
      editorImageSrc: null,
      imageSrc: null,
      imageKey: '',
      xZoom: 0,
      imgWidth: 0,
      imgHeight: 0,
      imgFilename: '',
      imgThumb: '',
      imgCopyright: '',
      path: '',
      imgBlockWidth: 0,
      imgBLockHeight: 0,
      imageDescription: '',
      showDescriptionInputField: true,
      scaleFree: false,
      allowSmallerImages: false, // false was default value in legacy system
      aiGenerated: false,
    };
    this.cropperRef = React.createRef();
  }

  /* needed functions for ImageEditor */

  rotateCropperImage = degree => {
    this.cropperRef.current.cropper.rotate(degree);
  };

  mirrorCropperImage = (x, y) => {
    this.cropperRef.current.cropper.scale(x, y);
  };

  zoomCropperImage = x => {
    let newX;

    this.setState(
      prevState => {
        const newXstate = parseFloat(x.toFixed(2));
        newX = newXstate - prevState.xZoom;
        return { xZoom: newXstate };
      },
      () => {
        this.cropperRef.current.cropper.zoom(newX);
      }
    );
  };

  resetCropperImage = () => {
    this.cropperRef.current.cropper.reset();
  };

  setCropperScaleFree = value => {
    const { scaleFree } = this.state;
    this.setState({ scaleFree: !scaleFree });
    this.cropperRef.current.cropper.setAspectRatio(value);
  };

  handleOnChange = (e, DataURIToBlob) => {
    const { attributes, imageUpload, id, clientImageRightsQuery } = this.props;
    const { imgBlockWidth, imgBlockHeight, allowSmallerImages } = this.state;

    let file;
    file = e.target.files[0];

    if (file) {
      const self = this; // Save the current this to use it inside callbacks
      EXIF.getData(file, function () {
        const Orientation = EXIF.getTag(this, 'Orientation');
        const img = new Image();
        img.src = createObjectURL(file);
        img.onload = () => {
          const minwidth = imgBlockWidth;
          const minheight = imgBlockHeight;
          let imgwidth = img.width;
          let imgheight = img.height;

          if (Orientation && Orientation !== 1) {
            const image = new Image();
            const imgCanvas = {};
            const reader = new FileReader();
            reader.onload = ev => {
              image.src = ev.target.result;
              image.onload = () => {
                const imgHeight = imgheight;
                const imgWidth = imgwidth;

                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = imgWidth;
                canvas.height = imgHeight;

                switch (Orientation) {
                  case 3: // rotate 180 degrees
                    ctx.rotate(Math.PI);
                    ctx.drawImage(image, -imgWidth, -imgHeight, imgWidth, imgHeight);
                    break;
                  case 6: // rotate - 90 degrees
                    canvas.width = imgHeight;
                    canvas.height = imgWidth;
                    ctx.rotate((3 * Math.PI) / 2);
                    ctx.drawImage(image, -imgWidth, 0, imgWidth, imgHeight);
                    // When the image is rotated 90 degrees, the width becomes the height and the height becomes the width (please pay attention to the difference between variables imgHeight and imgheight
                    imgwidth = imgHeight;
                    imgheight = imgWidth;
                    break;
                  case 8: // rotate 90 degrees
                    canvas.width = imgHeight;
                    canvas.height = imgWidth;
                    ctx.rotate(Math.PI / 2);
                    ctx.drawImage(image, 0, -imgHeight, imgWidth, imgHeight);
                    // When the image is rotated 90 degrees, the width becomes the height and the height becomes the width (please pay attention to the difference between variables imgHeight and imgheight
                    imgwidth = imgHeight;
                    imgheight = imgWidth;
                    break;
                }

                const dataUrl = canvas.toDataURL('image/jpeg', 0.1);
                imgCanvas.src = DataURIToBlob(dataUrl);
                imgCanvas.src = createObjectURL(imgCanvas.src);


                if ((imgwidth < minwidth || imgheight < minheight) && !allowSmallerImages) {
                  self.setState({
                    showImageTooSmallError: true,
                    showMedia: false
                  });
                } else if (imgwidth === minwidth && imgheight === minheight && !clientImageRightsQuery && !allowSmallerImages) {
                  self.setState({
                    showImageTooSmallError: false,
                    showMedia: false,
                    showImageEditor: false
                  }, () => {
                    self.update(imgCanvas.src);
                    imageUpload(id, file, null, attributes['data-name'], null, imgwidth, imgheight);
                  });
                } else {
                  self.setState({
                    showImageTooSmallError: false,
                    showMedia: false,
                    imageKey: null,
                    editorImageSrc: imgCanvas,
                    imageSrc: file,
                    imgWidth: imgwidth,
                    imgHeight: imgheight,
                    showImageEditor: true,
                  });
                }

                if (clientImageRightsQuery) {
                  self.imagePermissionQuery();
                }
              };
            };
            reader.readAsDataURL(file);
          } else if ((imgwidth < minwidth || imgheight < minheight) && !allowSmallerImages) {
            self.setState({ showImageTooSmallError: true, showMedia: false });
          } else if (imgwidth === minwidth && imgheight === minheight && !clientImageRightsQuery && !allowSmallerImages) {
            self.setState({ showImageTooSmallError: false, showMedia: false, showImageEditor: false }, () => {
              self.update(img.src);
              imageUpload(id, file, null, attributes['data-name'], null, imgwidth, imgheight);
            });
          } else {
            self.setState({
              showImageTooSmallError: false,
              showMedia: false,
              imageKey: null,
              editorImageSrc: img,
              imageSrc: file,
              imgWidth: imgwidth,
              imgHeight: imgheight,
              showImageEditor: true,
            });
            if (clientImageRightsQuery) {
              self.imagePermissionQuery();
            }
          }
        };
      });
    }
  };

  DataURIToBlob = dataURI => {
    const splitDataURI = dataURI.split(',');
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

    return new Blob([ia], { type: mimeString });
  };

  mimeTypeFromDataURI = dataURI => {
    const splitDataURI = dataURI.split(',');
    return splitDataURI[0].split(':')[1].split(';')[0];
  };

  imageUpload = () => {
    const { intl: { messages } } = this.props;
    const image = this.cropperRef.current?.cropper.getCroppedCanvas().toDataURL();
    const data = this.cropperRef.current?.cropper.getData(true);

    const { imageUpload, id, attributes } = this.props;
    const { imgBlockWidth, imgBlockHeight } = this.state;

    data.minWidth = imgBlockWidth;
    data.minHeight = imgBlockHeight;

    const {
      imageSrc,
      imageKey,
      imgWidth,
      imgHeight,
      imgFilename,
      imgThumb,
      imgCopyright,
      imageDescription,
    } = this.state;
    const imageBlob = this.DataURIToBlob(image);
    const imageUrl = URL.createObjectURL(imageBlob);
    const aiGeneratedText = messages.editor.ai_generated_hint || "This image was generated by AI";
    const copyright = this.state.aiGenerated ? aiGeneratedText : imgCopyright;


    this.update(imageUrl, copyright);

    /** @see creacheck/web/js/cc-editor/Editor.js uploadImage */
    imageUpload(
      id,
      imageSrc,
      imageKey,
      attributes['data-name'],
      data,
      imgWidth,
      imgHeight,
      imgFilename,
      imgThumb,
      imgCopyright,
      null,
      null,
      null,
      imageDescription
    );
    this.setState({
      showImageTooSmallError: false,
      showMedia: false,
      showImageEditor: false,
      xZoom: 0,
      editorImageSrc: '',
    });
  };

  update = (value, copyright) => {
    const { id, attributes, updateParam } = this.props;
    const overflow = false;
    const default_image = false;
    const errors = [{ overflow, default_image }];
    if (!copyright) {
      copyright = '';
    }
    updateParam(id, attributes['data-name'], value, errors, 'copyright_' + attributes['data-name'], copyright);
  };

  getSrc = () => {
    const { attributes, settings, params } = this.props;
    const param = _find(params, ['name', attributes['data-name']]);
    if (param) {
      return param.value;
    }
    if (attributes.src) {
      if (attributes.src === '{logo}' && settings) {
        return settings?.target?.client_main_logo?.variations[0]?.file?.web_link;
      }
      return attributes.src;
    }
    return 'nopic.jpg';
  };

  loadOriginal = (e, option) => {
    const { attributes } = this.props;
    const original = attributes['data-original'];
    const originalSrc = S3_LINKS.MEDIA_IMGS_ORIGINAL + original;
    const imgC = new Image();
    this.setState({ showDescriptionInputField: option });
    imgC.src = originalSrc;
    imgC.crossOrigin = 'anonymous';
    imgC.onload = () => {
      const imgwidth = imgC.width;
      const imgheight = imgC.height;
      this.setState({
        showImageTooSmallError: false,
        showMedia: false,
        showImageEditor: true,
        editorImageSrc: imgC,
        imageSrc: null,
        imageKey: original,
        imgWidth: imgwidth,
        imgHeight: imgheight,
        imgThumb: '',
        imgCopyright: '',
      });
    };
  };

  handleAiGeneratedImage = (checked) => {
    this.setState({ aiGenerated: checked });
  };

  loadMedia = (original, path, filename, thumb, copyright, files) => {
    this.setState({ showDescriptionInputField: true });
    // const original = e.target.getAttribute('data-original');
    let originalSrc = '';
    if (original === 'tp') {
      originalSrc = path;
    } else {
      originalSrc = path + original;
    }

    if (original === 'pixabay') {
      originalSrc = path;
      original = path;
    }

    const imgC = new Image();
    imgC.src = originalSrc;
    imgC.crossOrigin = 'anonymous';
    imgC.onload = () => {
      const imgwidth = imgC.width;
      const imgheight = imgC.height;
      this.setState({
        showImageTooSmallError: false,
        showMedia: false,
        showImageEditor: true,
        editorImageSrc: imgC,
        imageSrc: null,
        imageKey: original,
        imgWidth: imgwidth,
        imgHeight: imgheight,
        imgFilename: filename,
        imgThumb: thumb,
        imgCopyright: copyright,
        path,
      });

      if (original === 'tp') {
        this.setState({
          imageSrc: files,
          imageKey: null,
        });
      }
    };
  };
  // imageKey = orignal
  // path: null,

  changeImage = (newImage) => {
    const blob = this.DataURIToBlob(newImage.src);
    console.log('created blob from new image data URL:', blob);

    const filename = 'edited-image.png';
    const file = new File([blob], filename, { type: 'image/png' });
    console.log('created file from blob:', file);

    this.setState({
      editorImageSrc: newImage,
      imageSrc: file,
      imgWidth: newImage.width,
      imgHeight: newImage.height,
      imgFilename: filename,
      imageKey: null,
    });
    console.log('Image updated in state with new image data.');
  }

  loadMediaFromDataUrl = (dataUrl, width, height, filename = 'edited-image.png') => {
    const blob = this.DataURIToBlob(dataUrl);
    console.log('created blob from data URL:', blob);

    const mimetype = this.mimeTypeFromDataURI(dataUrl);
    if (mimetype !== 'image/jpeg' && mimetype !== 'image/png' && mimetype !== 'image/webp') {
      console.error('Unsupported image type:', mimetype);
      return;
    }

    const file = new File([blob], filename, { type: mimetype });
    console.log('created file from blob:', file);

    // Create an Image object and set src to the dataUrl
    const img = new window.Image();
    img.src = dataUrl;
    img.crossOrigin = 'anonymous';
    img.width = width;
    img.height = height;
    img.onload = () => {
      this.setState({
        editorImageSrc: img,
        imageSrc: file,
        imgWidth: width,
        imgHeight: height,
        imgFilename: filename,
        imageKey: null,
        showImageEditor: true,
        showMedia: false,
      });
      console.log('Image updated in state with new image data from data URL.');
    };
    img.onerror = (e) => {
      console.error('Failed to load image from data URL', e);
    };
  };

  handleMedia = (original, path, filename = '', thumb = '', copyright = '', files, description) => {
    if (description) {
      this.setImageDescription('description', description);
    }
    this.loadMedia(original, path, filename, thumb, copyright, files);
  };

  handleClick = () => {
    this.setState({ showMedia: true, showImageEditor: false });
  };

  handleFileUpload = (e, option) => {
    this.inputElement.click();
    this.setState({ showDescriptionInputField: option });
  };

  handleIEclose = () => {
    // this.cropperRef.current.destroy();
    this.inputElement.value = '';
    this.setState({
      showImageTooSmallError: false,
      showMedia: false,
      showImageEditor: false,
      editorImageSrc: '',
      xZoom: 0,
    });
  };

  updateImageSize = (width, height) => {
    this.setState({
      imgBlockWidth: width,
      imgBlockHeight: height,
    });
  };

  componentDidUpdate = () => {
    const { imgBlockWidth, imgBlockHeight } = this.state;
    // necessary if images are used that are below the minimum size
    if (
      this.imageRef.current?.offsetParent?.offsetWidth !== imgBlockWidth ||
      this.imageRef.current?.offsetParent?.offsetHeight !== imgBlockHeight
    ) {
      this.updateImageSize(
        this.imageRef.current.offsetParent?.offsetWidth,
        this.imageRef.current.offsetParent?.offsetHeight
      );
    }
  };

  componentDidMount = () => {
    /**
      const waitForIt = window.setInterval(() => {
        if (this.imageRef.current?.offsetParent?.offsetWidth > 0 && this.imageRef.current?.offsetParent?.offsetHeight > 0) {
        window.clearInterval(waitForIt);
        this.updateImageSize(this.imageRef.current.offsetParent?.offsetWidth,this.imageRef.current.offsetParent?.offsetHeight);
      }
          should no longer be needed...inside interval
        }, 100);
    */

    if (this.imageRef.current?.offsetParent?.offsetWidth > 0 && this.imageRef.current?.offsetParent?.offsetHeight > 0) {
      this.updateImageSize(this.imageRef.current.offsetParent?.offsetWidth, this.imageRef.current.offsetParent?.offsetHeight);
    }

  };

  setImageDescription = (name, value) => {
    this.setState({ imageDescription: value });
  };

  withImageClassName = () => {
    const { imageSrc, imageKey } = this.state;
    const { attributes, params } = this.props;

    if (imageSrc || imageKey) {
      return ' with-image';
    }

    const param = _find(params, ['name', attributes['data-name']]);
    if (param && param.value) {
      return ' with-image';
    }

    return '';
  }

  imagePermissionQuery = () => {
    const {
      intl: { messages },
    } = this.props;
    const options = {
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body" style={{ width: '100%' }}>
            <h1>{messages.image_permission_title}</h1>
            <p>{messages.image_permission_warning}</p>
            <div className="react-confirm-alert-button-group" style={{ width: '100%', margin: '0 auto' }}>
              <Button
                style={{ margin: '5px', width: '100px' }}
                variant="primary"
                onClick={() => {
                  onClose();
                  this.handleIEclose();
                }}
              >
                {messages.no}
              </Button>
              <Button
                style={{ margin: '5px', width: '100px' }}
                variant="warning"
                onClick={() => {
                  onClose();
                }}
              >
                {messages.yes}
              </Button>
            </div>
          </div>
        );
      },
      childrenElement: () => <div />,
      closeOnEscape: false,
      closeOnClickOutside: false,
    };

    confirmAlert(options);
  };

  render() {
    const { name: Tag, attributes, usedMedia, templateId, rootUser, params, disabled, settings } = this.props;
    const {
      showImageTooSmallError,
      showImageEditor,
      showMedia,
      editorImageSrc,
      xZoom,
      imgWidth,
      imgHeight,
      imgBlockWidth,
      imgBlockHeight,
      imageDescription,
      showDescriptionInputField,
      allowSmallerImages
    } = this.state;

    const canvasWidth = parseFloat(document.getElementsByTagName('body')[0].offsetWidth.toFixed(0)) - 200;
    const possibleZooms = parseFloat((imgWidth / canvasWidth).toFixed(0));
    const enable = { display: 'block' };
    const {
      intl: { messages },
    } = this.props;
    let originalSrc = '';
    const freeScale = attributes['data-freescale'];

    if (typeof attributes['data-original'] !== 'undefined' && typeof attributes['data-thumb'] !== 'undefined') {
      originalSrc = S3_LINKS.MEDIA_IMGS_THUMB + attributes['data-thumb'];
    }
    const previewImageCss = attributes['data-pre']
      ? '.cropper-face {opacity: 0.5; background: url(' +
      S3_LINKS.TEMPLATES +
      templateId +
      '/images/' +
      attributes['data-pre'] +
      ') center no-repeat;background-size: 100% 100%;}'
      : '';
    let blob = false;
    if (this.getSrc().includes('blob')) {
      blob = true;
    }

    const index = _.findIndex(params, param => param.name === attributes['data-name']);
    const _filter = params[index] && params[index].filter !== undefined ? params[index].filter : '';
    let allowedImageTypes = 'image/jpeg, image/png';
    const exportType = this.props.settings?.export_type?.value;
    if (exportType === '000000000000000000000003' || exportType === '000000000000000000000001') {
      allowedImageTypes = 'image/jpeg, image/png, image/webp';
    }
    return (
      <div className={"editor-image-content dropbox" + this.withImageClassName()}>
        <Tag ref={this.imageRef} {...attributes} src={this.getSrc()} style={{ filter: _filter }} />
        {blob && this.props.uploadError === true ? (
          <p className="uploadError">
            <i className="far fa-exclamation-triangle" />
          </p>
        ) : (
          <></>
        )}
        <div className={"fileclicker" + this.withImageClassName()} onClick={this.handleClick}>
          <p>
            {messages.editor.minimum_size} {imgBlockWidth} x {imgBlockHeight} Pixel
          </p>
        </div>

        <input
          ref={input => (this.inputElement = input)}
          type="file"
          accept={allowedImageTypes}
          onChange={e => {
            this.handleOnChange(e, this.DataURIToBlob);
          }}
        />
        {showImageTooSmallError && (
          <div id="infobox">
            <Alert>{messages.editor.too_low_resolution}</Alert>
          </div>
        )}
        {showMedia && (
          <ContextModal>
            <div id="contextModalWrap">
              <div id="contextModalStage" className="row">
                <MediaTabs
                  usedMedia={usedMedia}
                  loadMedia={this.loadMedia}
                  neededWidth={imgBlockWidth}
                  neededHeight={imgBlockHeight}
                  rootUser={rootUser}
                  originalSrc={originalSrc}
                  loadOriginal={this.loadOriginal}
                  handleFileUpload={this.handleFileUpload}
                  handleMedia={this.handleMedia}
                  attributess={attributes['data-thumb']}
                  saveDescription={this.props.saveDescription}
                  handleIEclose={this.handleIEclose}
                  handleOnChange={this.handleOnChange}
                  allowSmallerImages={allowSmallerImages}
                  loadMediaFromDataUrl={this.loadMediaFromDataUrl}
                  enableGenerativeImageService={!(settings?.disable_ai_features ?? false)}
                  handleAiGeneratedImage={this.handleAiGeneratedImage}
                />

                <Button variant="danger" size="large" onClick={this.handleIEclose} className="cancelIE">
                  {messages.editor.abort}
                </Button>
              </div>
            </div>
          </ContextModal>
        )}
        {showImageEditor && (
          <ContextModal style={enable}>
            <EditorApplyStyles styles={previewImageCss} />
            <div id="contextModalWrap">
              <div id="contextModalStage" className="image-editor">
                <ImageEditor
                  cropperRef={this.cropperRef}
                  editorImageSrc={editorImageSrc}
                  scaleFree={this.state.scaleFree}
                  freeScale={freeScale}
                  xZoom={xZoom}
                  possibleZooms={possibleZooms}
                  imageUpload={this.imageUpload}
                  rotateCropperImage={this.rotateCropperImage}
                  mirrorCropperImage={this.mirrorCropperImage}
                  zoomCropperImage={this.zoomCropperImage}
                  setCropperScaleFree={this.setCropperScaleFree}
                  messages={messages}
                  resetCropperImage={this.resetCropperImage}
                  imgBlockWidth={imgBlockWidth}
                  imgBlockHeight={imgBlockHeight}
                  imgWidth={imgWidth}
                  imgHeight={imgHeight}
                  disabled={disabled}
                  changeImage={this.changeImage}
                  handleAiGeneratedImage={this.handleAiGeneratedImage}
                  aiGenerated={this.state.aiGenerated}
                />
                <Loader />
                <Button
                  variant="danger"
                  size="large"
                  style={{ zIndex: 101 }}
                  onClick={this.handleIEclose}
                  className="cancelIE"
                >
                  {messages.editor.abort}
                </Button>
                {showDescriptionInputField ? (
                  <FormInput
                    type="text"
                    label={messages.editor.image_description}
                    name="description"
                    onChange={this.setImageDescription}
                    value={imageDescription}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
            <ReactTooltip id="bottom" place="bottom" effect="solid" />
          </ContextModal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    clientImageRightsQuery: state.login.user?.parent?.image_rights_query,
    clientSubscriptions: state.login.user?.subscriptions || [],
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(ImageElement)));
